export default "__VITE_ASSET__CifP8ubU__"